import { getPathTileArtStyle, type PathTileAtlasId } from '../pathArtStyles';

function createCanvas(width: number, height: number): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return canvas;
}

export function fillMaskedCanvasWithTexture(
  atlasId: PathTileAtlasId,
  target: HTMLCanvasElement,
  mask: CanvasImageSource,
  textureImage?: HTMLImageElement,
  textureTileScale?: number,
): void {
  if (!textureImage || !textureImage.complete) {
    return;
  }

  const context = target.getContext('2d');
  if (!context) {
    return;
  }

  const style = getPathTileArtStyle(atlasId);
  const baseWidth = textureImage.naturalWidth || textureImage.width;
  const baseHeight = textureImage.naturalHeight || textureImage.height;
  const scale = textureTileScale ?? style.textureTileScale ?? 1;
  const drawWidth = Math.max(1, Math.round(baseWidth * scale));
  const drawHeight = Math.max(1, Math.round(baseHeight * scale));

  const texturedCanvas = createCanvas(target.width, target.height);
  const texturedContext = texturedCanvas.getContext('2d');
  if (!texturedContext) {
    return;
  }

  texturedContext.imageSmoothingEnabled = false;
  for (let y = 0; y < target.height; y += drawHeight) {
    for (let x = 0; x < target.width; x += drawWidth) {
      texturedContext.drawImage(textureImage, x, y, drawWidth, drawHeight);
    }
  }

  texturedContext.globalCompositeOperation = 'destination-in';
  texturedContext.drawImage(mask, 0, 0, target.width, target.height);

  context.clearRect(0, 0, target.width, target.height);
  context.drawImage(texturedCanvas, 0, 0);
}
